'use strict';

module.exports = function assign(target) {
  var objs = Array.prototype.slice.call(arguments, 1);

  objs.forEach(function (obj) {
    if (typeof obj !== 'object') { return; }

    Object.keys(obj).forEach(function (key) {
      target[key] = obj[key];
    });
  });

  return target;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@braintree/iframer/lib/assign.js
// module id = 307
// module chunks = 0